module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-11.a4b22994.png";